import { de, el, enUS as en, et, fr, it, pt } from 'date-fns/locale';
import { capitalize } from 'lodash';

export const locales = {
  en,
  it: {
    ...it,
    localize: {
      ...it.localize,
      // @ts-expect-error args typed as any[]
      day: (...args) => capitalize(it.localize.day(...args)),
      // @ts-expect-error args typed as any[]
      month: (...args) => capitalize(it.localize.month(...args)),
    },
  },
  de,
  pt: {
    ...pt,
    localize: {
      ...pt.localize,
      // @ts-expect-error args typed as any[]
      day: (...args) => capitalize(pt.localize.day(...args)),
      // @ts-expect-error args typed as any[]
      month: (...args) => capitalize(pt.localize.month(...args)),
    },
  },
  fr: {
    ...fr,
    localize: {
      ...fr.localize,
      // @ts-expect-error args typed as any[]
      day: (...args) => capitalize(fr.localize.day(...args)),
      // @ts-expect-error args typed as any[]
      month: (...args) => capitalize(fr.localize.month(...args)),
    },
  },
  el: {
    ...el,
    localize: {
      ...el.localize,
      // @ts-expect-error args typed as any[]
      day: (...args) => capitalize(el.localize.day(...args)),
      // @ts-expect-error args typed as any[]
      month: (...args) => capitalize(el.localize.month(...args)),
    },
  },
  et: {
    ...et,
    localize: {
      ...et.localize,
      // @ts-expect-error args typed as any[]
      day: (...args) => capitalize(et.localize.day(...args)),
      // @ts-expect-error args typed as any[]
      month: (...args) => capitalize(et.localize.month(...args)),
    },
  },
} as const;

export type Locale = (typeof locales)[keyof typeof locales];
